import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	sources_title: {
		id: 'search_ai.sources_label',
		defaultMessage: '{numSources, plural, =1 {Source} other {Sources}}',
		description: 'Label text for the sources section of the AI Answer component',
	},
});
